module.exports = __webpack_public_path__ + "img/2022-04-19_12-21-42.fe88fc6e.jpg";